// extracted by mini-css-extract-plugin
module.exports = {"container":"Paypage_container__uFoQu","cbLockIcon":"Paypage_cbLockIcon__27U16","cbContentInformation":"Paypage_cbContentInformation__34zL4"};